import React, { useEffect, useMemo, useRef, useState } from 'react'

import { TooltipProps } from './Tooltip.types'
import Popup from '../Popup/Popup'

const Tooltip: React.FC<TooltipProps> = ({
    pos = 'bottom',
    vertical = 'top',
    show = false,
    children,
    content,
    anchor,
    color = '#000',
    backgroundColor = '#fff',
    width = null,
    type = 'light',
    isDisabled = false,
    positioning,
}) => {
    const internalRef = useRef(null)
    const [internalShow, setInternalShow] = useState(show)

    const handleEnter = () => {
        setInternalShow(true)
    }
    const handleLeave = () => {
        setInternalShow(false)
    }

    useEffect(() => {
        if (internalRef.current) {
            internalRef.current.addEventListener('mouseenter', handleEnter)
            internalRef.current.addEventListener('mouseleave', handleLeave)
        }
        return () => {
            if (internalRef.current) {
                internalRef.current.removeEventListener('mouseenter', handleEnter)
                internalRef.current.removeEventListener('mouseleave', handleLeave)
            }
        }
    }, [isDisabled, internalRef.current])

    const posClass = useMemo(() => {
        if (positioning && positioning[1] === 2) {
            return 'bottom'
        }
        return 'top'
    }, [positioning])

    return (
        <React.Fragment>
            {typeof children === 'function' ? children(internalRef) : null}
            <Popup
                positioning={positioning}
                align={'middle'}
                pos={pos}
                show={!isDisabled && internalShow}
                // show={!isDisabled && internalShow}
                // show={internalRef.current ? internalShow : show}
                width={width}
                anchor={internalRef.current ? internalRef : anchor}
                wrapperStyle={{ overflow: 'visible' }}
                bodyStyle={{
                    overflow: 'visible',
                    boxShadow: 'rgb(67 90 111 / 30%) 0px 0px 1px, rgb(67 90 111 / 27%) 0px 8px 10px -4px',
                }}
            >
                <div
                    data-testid='Tooltip'
                    className={`r-tooltip-container r-pos-${posClass} r-type-${type} r-vertical-${vertical}`}
                    style={{ backgroundColor, color }}
                >
                    <div className={'r-tooltip-triangle'} style={{ borderBottomColor: backgroundColor }} />
                    {typeof children === 'function' ? content : children}
                </div>
            </Popup>
        </React.Fragment>
    )
}

export default Tooltip
